import { useIsExpired, useIsExpiredWithNavigation } from 'app/hooks/use-is-expired';
import { ListingType } from 'app/types/listing';
import type { NewScreenParams } from 'app/screens/new/index';
import type { SpecificNavigationProp } from 'app/types/navigation';

export function useOpenNewWithGuard() {
  const authorize = useIsExpired();
  return useOpenNewWithGuardBase(authorize);
}

export function useOpenNewWithGuardForNavigation(navigation: SpecificNavigationProp) {
  const authorize = useIsExpiredWithNavigation(navigation);
  return useOpenNewWithGuardBase(authorize);
}

function useOpenNewWithGuardBase(authorize: (cb: () => unknown) => unknown) {
  const openNewWithGuard = (
    navigation: SpecificNavigationProp,
    screenParams: NewScreenParams,
    mode: 'navigate' | 'replace' = 'navigate',
  ) => {
    const type = screenParams.defaultValues?.type;

    const navigateToNew = () => {
      if (mode === 'replace') {
        navigation.replace('new', screenParams);
      } else {
        navigation.navigate('new', screenParams, { pop: true });
      }
    };

    // If it's a "request" (need) ensure license check runs first.
    if (type === ListingType.request) {
      authorize(navigateToNew);
      return;
    }

    navigateToNew();
  };

  return openNewWithGuard;
}
